import React from "react";
import Grid from "@material-ui/core/Grid";
import KeyItem from "./KeyItem";
import keyboardCharacters from "../../util/keyboard/keyboards.json";

function QwertyKeyboard(props) {
  var keyboard = keyboardCharacters.captialEnglishLetters;
  var additionalMargin = 40;
  const images = importAllKeyBoardImages(
    require.context("../../resources/", false, /\.(png|jpeg|svg)$/)
  );

  function importAllKeyBoardImages(resourceImages) {
    let images = {};
    resourceImages.keys().forEach((item, index) => {
      images[item.replace("./", "")] = resourceImages(item);
    });
    return images;
  }

  return (
    <div>
      <Grid container id="QwertyKeyboard">
        {keyboard.map((keys, index) => (
          <Grid
            key={index}
            item
            container
            xs={12}
            style={{
              paddingLeft: 5 + index * additionalMargin,
              paddingRight: index * additionalMargin,
              paddingTop: 5,
              paddingBottom: 5,
            }}
            justifyContent="space-between"
            alignItems="stretch"
          >
            {keys.map((characters, index) => (
              <Grid item xs={characters.noofcolumns} key={index}>
                <KeyItem
                  alphabet={characters.letter}
                  onClick={props.onClick}
                  image={images[characters.image]}
                  idVal={characters.id}
                />
              </Grid>
            ))}
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default QwertyKeyboard;
